var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "body_1",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.28125 0 0 0.28125 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.81 0 0 2.81 1.4065934 1.4065934)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M45 82.258C 32.713 82.258 22.716 72.261 22.716 59.974003C 22.716 47.687004 32.713 37.69 45 37.69C 57.287 37.69 67.283005 47.685997 67.283005 59.973C 67.283005 72.26 57.287 82.258 45 82.258zM45 43.69C 36.021 43.69 28.716 50.995 28.716 59.973C 28.716 68.951996 36.021 76.257 45 76.257C 53.979 76.257 61.283 68.952 61.283 59.973003C 61.283 50.995 53.979 43.69 45 43.69z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M70.034 69.667L63.088997 69.667C 61.431995 69.667 60.088997 68.324 60.088997 66.667C 60.088997 65.01 61.431995 63.667 63.088997 63.667L63.088997 63.667L70.034 63.667C 77.735 63.667 84 57.402 84 49.701C 84 42 77.735 35.736 70.034 35.736L70.034 35.736L69.711 35.736C 68.187996 35.736 66.906 34.594 66.730995 33.081C 65.455 22.056 56.113 13.742 45 13.742C 33.888 13.742 24.545 22.056 23.269 33.079998C 23.094 34.593998 21.811998 35.734997 20.289 35.734997L20.289 35.734997L19.966 35.734997C 12.265 35.736 6 42 6 49.701C 6 57.402 12.264999 63.667 19.966 63.667L19.966 63.667L26.911 63.667C 28.567999 63.667 29.911 65.01 29.911 66.667C 29.911 68.324 28.567999 69.667 26.911 69.667L26.911 69.667L19.966 69.667C 8.957 69.667 0 60.71 0 49.701C 0 39.451 7.764 30.981 17.719 29.861C 20.396 17.087 31.704 7.742 45 7.742C 58.297 7.742 69.604996 17.087 72.281 29.861C 82.236 30.981 90 39.452 90 49.701C 90 60.71 81.043 69.667 70.034 69.667z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M51.041 68.974C 50.273 68.974 49.506 68.681 48.920002 68.095L48.920002 68.095L36.920002 56.095C 35.748 54.924 35.748 53.025 36.920002 51.853C 38.092003 50.681 39.992 50.681 41.163002 51.853L41.163002 51.853L53.163002 63.853C 54.335003 65.024 54.335003 66.923004 53.163002 68.095C 52.576 68.681 51.809 68.974 51.041 68.974z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 0 0)",
    d: "M39.041 68.974C 38.273 68.974 37.505 68.681 36.919 68.095C 35.747997 66.923004 35.747997 65.024 36.919 63.853L36.919 63.853L48.919 51.853C 50.091 50.681 51.989 50.681 53.161 51.853C 54.333 53.025 54.333 54.924 53.161 56.095L53.161 56.095L41.161 68.095C 40.576 68.681 39.808 68.974 39.041 68.974z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionError);
export default __webpack_public_path__ + "static/media/ConnectionError.4badfea2e5e237c5538faa6077be8ff1.svg";
export { ForwardRef as ReactComponent };